import axios, { AxiosRequestConfig } from "axios";
import { handleRequest, handlError, handleSuccess } from "./config";
export class AxiosSecondService {
    readonly service;
    constructor() {
        const service = axios.create({
            responseType: "json",
            baseURL: process.env.REACT_APP_API_SALEKIT_NET_URL || '',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        service.interceptors.request.use(handleRequest)
        service.interceptors.response.use(handleSuccess, handlError);
        this.service = service;
    }

    async get<T>(
        endpoint: string,
        options?: AxiosRequestConfig
    ): Promise<T> {
        return this.service.get(endpoint, options);
    }

    async post<T>(
        endpoint: string,
        payload: any,
        options?: AxiosRequestConfig
    ): Promise<T> {
        return this.service.post(endpoint, payload, options);
    }

    async put<T>(
        endpoint: string,
        payload: any,
        options?: AxiosRequestConfig
    ): Promise<T> {
        return this.service.put(endpoint, payload, options);
    }

    async patch<T>(
        endpoint: string,
        payload: any,
        options?: AxiosRequestConfig
    ): Promise<T> {
        return this.service.patch(endpoint, payload, options);
    }

    async delete<T>(
        endpoint: string,
        options?: AxiosRequestConfig
    ): Promise<T> {
        return this.service.delete(endpoint, options);
    }

}
const axiosSecondService = new AxiosSecondService();
export default axiosSecondService;